/*
 * space.js
 * --------
 * Exports the space component.
 */

import React from "react";
import PropTypes from "prop-types";

import styles from "./space.module.scss";

const Space = ({ size }) => (
  <div
    className={styles.spaceBlock}
    style={{ fontSize: size }}
  />
);

Space.defaultProps = {
  size: "1rem",
};

Space.propTypes = {
  size: PropTypes.string,
};

export default Space;
